module.exports = __webpack_public_path__ + "media/images/lb/897-0236803e29001495ff93f23fa79d82cd.svg";